module.exports = __webpack_public_path__ + "static/media/sistema-multas-plano-starter.f5058ebe.png";